function mapChildElementsToPayload(elements) {
  if (!elements) return [];
  return elements.map((childItem) => ({
    ...(childItem?.newlyCreated ? {} : { id: childItem?.id }),
    key: childItem?.keyName,
    label: childItem?.labelName,
    order: childItem?.order || "",
    ...(childItem?.placeholder?.length
      ? { place_holder: childItem?.placeholder }
      : {}),
    type: childItem?.formElementType?.toLowerCase(),
    required: childItem?.required || false,
    status: childItem?.statusField?.toLowerCase(),
    ...(childItem?.parentValue ? { parent_value: childItem?.parentValue } : {}),
    ...(childItem?.options ? { options: childItem?.options } : {}),
    ...(childItem?.elements
      ? { elements: mapChildElementsToPayload(childItem?.elements) }
      : {}),
  }));
}

function mapSavedItemToPayloadElement(item) {
  let element = {
    ...(item?.parent ? {} : { id: item?.id }),
    key: item?.keyName || "",
    label: item?.labelName || "",
    order: item?.order || "",
    ...(item?.placeholder?.length
      ? { place_holder: item?.placeholder || "" }
      : {}),
    required: item?.required || false,
    status: item?.statusField?.toLowerCase() || "",
    type: item?.formElementType?.toLowerCase() || "",
    ...(item?.elements
      ? { elements: mapChildElementsToPayload(item?.elements) }
      : {}),
  };
  if (item?.formElementType === "select") {
    const options = item?.optionsData?.map((option) => ({
      value: option.toLowerCase(),
      label: option,
    }));
    element.options = options;
  } else if (item?.formElementType === "multiple_choice_grid") {
    const rows = item?.rowOptionData || [];
    const columns = item?.columnOptionData || [];
    element.options = { rows, columns };
  } else if (
    item?.formElementType === "radio" ||
    item?.formElementType === "checkbox"
  ) {
    element.options = item?.optionsData || [];
  } else if (item?.formElementType === "linear") {
    element.options = {
      min: item?.options?.min,
      max: item?.options?.max,
      prefix: item?.options?.prefix,
      suffix: item?.options?.suffix,
    };
  } else if (item?.formElementType === "scale") {
    const display_value = item?.otherDisplayValueOptions || [];
    const data_value = item?.otherDataValueOptions || [];
    element.options = { display_value, data_value };
  } else if (item?.formElementType === "information") {
    element.options = item?.options;
  }
  return element;
}

export function buildFormSubmitPayload({
  name,
  responseNotification,
  emails,
  formIds,
  description,
  status,
  is_public,
  accessLevel,
  submitMessageRef,
  email_displayed,
  email_required,
  savedData,
}) {
  const payload = {
    name: name,
    response_email: +responseNotification,
    ...(responseNotification ? { response_email_to: emails.join(",") } : {}),
    ...(formIds
      ? { description: description?.length ? description : "" }
      : description?.length
      ? { description }
      : {}),
    status: status?.toLowerCase() || "",
    is_public: is_public?.toLowerCase() === "shared",
    access_level_id: is_public?.toLowerCase() === "shared" ? accessLevel : 0,
    ...(formIds
      ? {
          submit_message: submitMessageRef?.current?.getContent()?.length
            ? submitMessageRef?.current?.getContent()
            : "",
        }
      : submitMessageRef?.current?.getContent()?.length
      ? { submit_message: submitMessageRef?.current?.getContent() }
      : {}),
    email_displayed,
    email_required,
  };

  if (savedData?.length) {
    const elementData = savedData?.map(mapSavedItemToPayloadElement);
    if (elementData.length > 0) {
      payload.elements = elementData;
    }
  }

  return payload;
}
